document.getElementById('rv-theme-toggle')?.addEventListener('click', () => {
  const dark = document.documentElement.dataset.tema !== 'dark';
  document.documentElement.dataset.tema = dark ? 'dark' : 'light';
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') document.querySelectorAll('.rv-menu[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
});
document.addEventListener('click', (event) => {
  document.querySelectorAll('.rv-menu[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
});
